import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchDeleteOrganizationFromProject } from '../services/patchRemoveOrganizationFromProject.service';

export const deleteBusinessOrganizationFromProject = createAsyncThunk(
  'organizationCharts/deleteBusinessOrganizationFromProject',
  async (organizationChartItemIdToDelete, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchDeleteOrganizationFromProject(
      selectedProjectId,
      organizationChartItemIdToDelete
    );

    return response;
  }
);
